


export const pageTransitions = {
    in: {
        opacity: 1,
        y: '0vh'
    },
    out: {
        opacity: 0,
        x: '1vh'
    },
    initial: {
        opacity: 0,
        y: '1vh'
    }
}

export const homepageTransitions = {
    in: {
        opacity: 1
    },
    out: {
        opacity: 0
    },
    initial: {
        opacity: 0
    }
}

export const loginContainerTransition = {
    in: {
        opacity: 1,
        y: '-50%',
        x: '-50%',
    },
    out: {
        opacity: 0,
        x: '-47%',
        y: '-50%',
    },
    initial: {
        opacity: 0,
        x: '-50%',
        y: '-47%',
    }
}

export const backdropTransition = {
    in: {
        opacity: 1,
    },
    out: {
        opacity: 0,
    },
    initial: {
        opacity: 0,
    }
}

export const drawerTransition = {
    in: {
        x: '0%',
        transition: 'ease-out'
    },
    out: {
        x: '100%',
        transition: 'ease-in'
    },
    initial: {
        x: '100%',
        transition: 'ease-out'
    }
}

export const popupTransition = {
    in: {
        y: '-50%',
        x: '-50%',
        scale: 1,
        zIndex: 51,
        opacity: 1
    },
    out: {
        y: '-47.5%',
        x: '-50%',
        scale: 0.97,
        zIndex: 51,
        opacity: 0
    },
    initial: {
        y: '-47.5%',
        x: '-50%',
        scale: 0.97,
        zIndex: 51,
        opacity: 0
    }
}

export const quoteAnimation = {
    in: {
        x: '0%',
        scale: 1,
        opacity: 1
    },
    out: {
        x: '10%',
        scale: 0.9,
        opacity: 0,
    },
    initial: {
        x: '-10%',
        scale: 0.9,
        opacity: 0,
    }
}

export const openTopRight = {
    in: {
        x: '0%',
        y: '0%',
        scale: 1,
        opacity: 1
    },
    out: {
        x: '5%',
        y: '-5%',
        scale: 0.9,
        opacity: 0,
    },
    initial: {
        x: '5%',
        y: '-5%',
        scale: 0.9,
        opacity: 0,
    }
}

export const transitionDuration = .2
export const modalTransitionDuration = .25
export const quoteTransitionDuration = .4
